export default "__VITE_ASSET__BB61dkpa__"